import type { SdmEvent } from '../../../data-structures/sdmEventTypes';

/**
 * POST a simulated event to the interlink-ai (connect-ai) backend's injection endpoint,
 * which feeds it into the analysis-stage callbacks — exercising the real networking
 * (SSE + TCP) and database paths without any video being decoded. The event is sent in
 * the same SSE output shape the backend would normally emit, so it round-trips back to
 * this client over the live SSE stream.
 *
 * Auth mirrors the SSE subscription (see useServerSentEvents): the device is reached
 * directly (not via vd-server), with the JWT carried as a `jwt` query param plus
 * credentialed cookies, since this path is not a typed vd-server Hono call.
 */
export async function injectSimulatedEvent(
  baseUrl: string,
  accessToken: string,
  event: SdmEvent,
): Promise<void> {
  const url = new URL(`${baseUrl}/ai/modules/line_crossing/events/inject`);
  url.searchParams.set('jwt', accessToken);

  const response = await fetch(url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(event),
  });

  if (!response.ok) {
    const detail = await response.text().catch(() => '');
    throw new Error(`injection failed: ${response.status} ${response.statusText} ${detail}`.trim());
  }
}
